export const CTA_ACTIONS = {
  OPEN_MODAL: 'OPEN_MODAL',
  API_CALL: 'API_CALL',
  CLOSE_MODAL: 'CLOSE_MODAL',
  EXTERNAL_LINK: 'EXTERNAL_LINK',
  INTERNAL_LINK: 'INTERNAL_LINK',
};

export const CTA_TYPES = {
  LINK: 'LINK',
  BUTTON: 'BUTTON',
  ICON: 'ICON',
  LINK_BUTTON: 'LINK_BUTTON',
  COUNTER_BUTTON: 'COUNTER_BUTTON',
  RADIO: 'RADIO',
  CHECKBOX: 'CHECKBOX',
  RHFCheckBox: 'RHFCheckBox', //TODO remove this and use CHECKBOX
};
